$(document).ready(function(){
    $('img[src="//gasihouse.com/cdn/shop/files/Untitled_design-Photoroom_f17f5035-cea5-477a-a6af-e41641137b0c.png?v=1742737760&width=1100"]').attr('alt', 'Gasi House logo');

setTimeout(() => {
     $('a[id^="CardLink"]').each(function () {
    var label = $(this).text().trim().replace(/"/g, '');
    if (label) {
        $(this).attr('aria-label', 'View product: ' + label);
    }
    $(this).removeAttr('aria-labelledby');
});

$('a[id^="StandardCardNoMediaLink"]').each(function () {
     var label = $(this).text().trim().replace(/"/g, '');
    if (label) {
        $(this).attr('aria-label', label);
    }
    $(this).removeAttr('aria-labelledby');
});
}, 1000);
   $("img[src=\"//gasihouse.com/cdn/shop/files/ChatGPTImageFeb15_2026_06_32_25AM.png?v=1771155344&width=1946\"]").attr("alt", "Jungle Gelato logo with ice cream cone and jungle background");
$("img[src=\"//gasihouse.com/cdn/shop/files/Untitled_design_3.png?v=1771155356&width=1946\"]").attr("alt", "Green cannabis buds with Gasi House logo");
$("img[src=\"//gasihouse.com/cdn/shop/files/Untitled_design-Photoroom_f17f5035-cea5-477a-a6af-e41641137b0c.png?v=1742737760&width=1100\"]").attr("alt", "Gasi House logo");

$("img[src=\"//gasihouse.com/cdn/shop/files/ChatGPTImageFeb15_2026_06_27_06AM.png?v=1771154841&width=1946\"]").attr("alt", "Maui Wowie logo with beach scene");
$("img[src=\"//gasihouse.com/cdn/shop/files/Untitled_design_4.jpg?v=1771154851&width=1946\"]").attr("alt", "Maui Wowie cannabis buds with Gasi House logo");

$("img[src=\"//gasihouse.com/cdn/shop/files/puffy3.jpg?v=1771155777&width=1946\"]").attr("alt", "Yellow vape pen and packaging with \"JUICE MAN\" and \"Gasi House\" text");
$("img[src=\"//gasihouse.com/cdn/shop/files/puffy4.jpg?v=1771155819&width=1946\"]").attr("alt", "Yellow vape pen and packaging with \"BUTTERSCOTCH\" and \"Puppy\" text");

$("img[src=\"//gasihouse.com/cdn/shop/files/Puffy_90A.png?v=1750397457&width=1946\"]").attr("alt", "Yellow vape cartridge and packaging with \"Pure THCa 90A Resin\" text");

let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;


   
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 $("img.add-to-cart__success").attr("alt","add to cart success");     
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}
setTimeout(function(){

    $("#adabundle-action-align-right > div > span.adabundle-title").text('Right Aligned');
},3000)

    console.log("ready");
});
